import { v4 as uuidv4 } from 'uuid'
import type {
  SnapchatEvents,
  TiktokEvents,
} from '#shared/types'

interface PixelEvents {
  meta?: string
  google?: string
  snapchat?: SnapchatEvents
  tiktok?: TiktokEvents
}

interface UserData {
  email?: string
  first_name?: string
  last_name?: string
  phone?: string
}

interface CustomData {
  value: number
  currency: string
}

const metaStandardEventNames = [
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'InitiateCheckout',
  'Lead',
  'Purchase',
  'Schedule',
  'Search',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
  'ViewContent',
]

export default function () {
  const {
    meta,
    snapchat,
    google,
    // tiktok,
    enable_tracking,
  } = getData().data
  const { base_url } = useRuntimeConfig().public

  const route = useRoute()
  const fbpCookie = useCookie('_fbp')
  const fbcCookie = useCookie('_fbc')
  const fbp = fbpCookie.value || undefined
  const fbc = fbcCookie.value || undefined
  const event_source_url = window ? window.location.origin + window.location.pathname : base_url + route.path

  const meta_event_time = Math.floor(new Date().valueOf() / 1000)
  const event_id = uuidv4()

  const {
    gAnalytics,
    metaPixel,
    snapPixel,
  } = usePixels()

  function event(events: PixelEvents, user_data?: UserData, custom_data?: CustomData) {
    debug(`[Track: ${enable_tracking}]`, events)
    if (!enable_tracking || !import.meta.client) return {
      meta_event_time,
      event_id,
    }

    // const { enable_gtm } = useRuntimeConfig().public
    // if (enable_gtm) {
    //   const gtm = useGtm() // auto-imported by the module
    //   return
    // }

    if (metaPixel && meta.enable && events.meta) {
      if (metaStandardEventNames.includes(events.meta)) {
        metaPixel.proxy.fbq('track', events.meta, custom_data, { event_id })
      }
      else {
        metaPixel.proxy.fbq('trackCustom', events.meta, custom_data, { event_id })
      }
    }

    if (snapchat.enable && events.snapchat) {
      if (!snapPixel?.proxy?.snaptr) {
        console.warn('Snapchat Pixel is not properly initialized or loaded.')
        return
      }

      snapPixel.proxy.snaptr('track', events.snapchat, {
        price: custom_data?.value,
        currency: custom_data?.currency,
        client_deduplication_id: event_id,
        user_email: user_data?.email,
        user_phone_number: user_data?.phone,
        firstname: user_data?.first_name,
        lastname: user_data?.last_name,
      })
    }

    if (gAnalytics && google.enable && events.google) {
      gAnalytics.proxy.gtag('event', events.google, custom_data)
    }

    // if (tiktok.enable && events.tiktok) {
    //   if ('ttq' in window) {
    //     window.ttq.track(events.tiktok, {
    //       event_id: event_id,
    //       currency: custom_data?.currency,
    //       value: custom_data?.value,
    //     })
    //   }
    // }
  }

  return {
    event,
    fbp,
    fbc,
    event_source_url,
    meta_event_time,
    event_id,
  }
}
